import { Breakpoint } from '@/enums'
import { IconBackground } from '@/pages/SelfAssessmentPage/public/styles'
import { theme } from '@/theme'
import { themeBreakpointUp } from '@/utils'
import { Button } from '@surein/ui'
import { ArrowRight, Check } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { useStepper } from '../../hooks/useStepper'

const SuccessStepContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: calc(100vh - 86px);

  ${themeBreakpointUp(Breakpoint.md)} {
    height: 77vh;
  }
`

const ThankYouContainer = styled.div`
  flex: 1;
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-width: 300px;
  gap: 1rem;
`
const TextAlign = styled.p`
  text-align: center;
`
const Footer = styled.div`
  padding: 24px;
`
export const SuccessStep = () => {
  const { t } = useTranslation()
  const { onNext } = useStepper()

  return (
    <SuccessStepContainer>
      <ThankYouContainer>
        <IconBackground>
          <Check color={theme.color.b0} height="36px" width="36px" />
        </IconBackground>
        <h2>{t('yearlyAssessment.successStep-title')}</h2>
        <TextAlign>{t('yearlyAssessment.successStep-description')}</TextAlign>
      </ThankYouContainer>
      <Footer>
        <Button
          onClick={() => onNext()}
          suffixIcon={ArrowRight}
          variant="primary"
          shape="square"
        >
          {t('yearlyAssessment.successStep-cta')}
        </Button>
      </Footer>
    </SuccessStepContainer>
  )
}
